export default "__VITE_ASSET__DsZXcF7Q__"